import Utils from "../utils/Utils";
import { LoanVM, LoanItem, LoanRequest, LoanApprovalModel, UnpaidLoanItemRequestModel, LoanStatus } from "../models/Loan";
import ApiService from "./ApiService";
import ListResult from "../viewModels/response/ListResult";
import PaginationRequestModel from "../viewModels/request/PaginationRequestModel";
import { LoanListResult } from "../services/openApi/api";

export default class LoanService {
  public static async add(model: LoanVM): Promise<LoanVM> {
    return new Promise((resolve, reject) => {
      ApiService.post("/loan", model)
        .then((res) => {
          resolve(model);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public static async addByAdmin(model: LoanVM): Promise<LoanVM> {
    return new Promise((resolve, reject) => {
      ApiService.post("/loan/addByAdmin", model)
        .then((res) => {
          resolve(model);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public static async update(model: LoanVM): Promise<LoanVM> {
    return new Promise((resolve, reject) => {
      ApiService.put("/loan", model)
        .then((res) => {
          resolve(model);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public static async delete(id: string): Promise<string> {
    return new Promise((resolve, reject) => {
      ApiService.delete(`/loan/${id}`)
        .then((res) => {
          resolve(id);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public static async deleteByAdmin(id: string): Promise<string> {
    return new Promise((resolve, reject) => {
      ApiService.delete(`/loan/deleteByAdmin/${id}`)
        .then((res) => {
          resolve(id);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public static async approval(model: LoanApprovalModel) {
    return new Promise((resolve, reject) => {
      ApiService.put("/loan/approval", model)
        .then((res) => {
          resolve("");
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public static async payment(model: LoanApprovalModel) {
    return new Promise((resolve, reject) => {
      ApiService.put("/loan/payment", model)
        .then((res) => {
          resolve("");
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public static async getList(paginationModel: PaginationRequestModel): Promise<LoanListResult> {
    return new Promise((resolve, reject) => {
      const url = "/loan/getByTeammemberId";

      ApiService.post(`${url}`, paginationModel)
        .then((result) => {
          resolve(result.data as LoanListResult);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public static async getAll(model: LoanRequest, isTeammember = true): Promise<LoanListResult> {
    return new Promise((resolve, reject) => {
      ApiService.post("/loan/getAll", model)
        .then((result) => {
          resolve(result.data as LoanListResult);
        })
        .catch((error) => reject(error));
    });
  }

  public static async GetLastUnpaidItemOfLoanByTeamMemberId(model: UnpaidLoanItemRequestModel): Promise<LoanItem[]> {
    return new Promise((resolve, reject) => {
      const url = "/loan/getLastUnpaidItemOfLoanByTeamMemberId";

      ApiService.post(`${url}`, model)
        .then((result) => {
          if (!result.data) {
            resolve([]);
          } else {
            resolve(result.data as LoanItem[]);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public static async loanInstallmentPayment(model: LoanItem[], payRunId: string, isTeammember = true): Promise<LoanVM[]> {
    return new Promise((resolve, reject) => {
      ApiService.put(`/loan/installmentPayment/${payRunId}`, model)
        .then((result) => {
          if (!result.data) {
            resolve([]);
          } else {
            resolve(result.data as LoanVM[]);
          }
        })
        .catch((error) => reject(error));
    });
  }

  public static getLoanStatuses() {
    const statuses = [
      { status: 0, value: "Pending" },
      { status: 1, value: "Approved" },
      { status: 2, value: "Rejected" },
      { status: 3, value: "FullyPaid" },
    ];
    return statuses;
  }

  public static CanBeDeleted(loan: LoanVM): Boolean {
    return loan.Status == LoanStatus.Pending;
  }
}
